import React from 'react';

const SobreNosotros = () => {
  return (
    <section className="pb-lg-22">
      <div className="container">
        <div className="row align-items-center mt-n1-6 mt-sm-n6">
          {/* Imagen principal con contenido */}
          <div className="col-lg-5 mt-1-6 mt-sm-6">
            <div className="position-relative text-center text-lg-start">
              <img
                src="/assets/img/productos/techo-plafon-falso/plafon-falso-intro.jpg"
                alt="..."
              />
              <div className="position-absolute bottom-n10 right-n10 right-lg-n30 d-none d-sm-block">
                <img
                  src="/assets/img/productos/techo-plafon-falso/plafon-falso-intro-small.png"
                  alt="..."
                  style={{ width: '300px', height: '300px' }}
                />
              </div>
            </div>
          </div>

          {/* Texto descriptivo */}
          <div className="col-lg-7 mt-1-6 mt-sm-6">
            <div className="ps-lg-2-9 ps-xl-10">
              <div className="mb-1-9 mb-xl-8">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">
                Versátil y funcional
                </span>
                <h2 className="mb-1-6 display-5 font-weight-800 lh-1">
                Plafón Falso de PVC: Estilo y Funcionalidad para tus Espacios
                </h2>
              </div>
              <div className="ps-1-9 ps-sm-10 ps-lg-20">
                <p className="mb-1-6 mb-sm-2-2">
                El plafón falso de PVC es una solución innovadora y versátil para transformar techos y paredes con diseño, practicidad y durabilidad. 
                Diseñado para satisfacer las necesidades de arquitectos y diseñadores, este material combina estética moderna con beneficios técnicos que lo 
                hacen ideal para proyectos residenciales, comerciales e industriales.
                </p>
                <ul className="list-style6 mb-1-9 mb-sm-5">
                  <li className="text-dark">Resistencia al Agua y a la Humedad</li>
                  <li className="text-dark">Durabilidad Prolongada</li>
                  <li className="text-dark">Estética Moderna y Versátil</li>
                  <li className="text-dark">Ligero y de Fácil Instalación</li>
                  <li className="text-dark">Mínimo Mantenimiento</li>
                </ul>
                <a href="contacto-decototal" className="butn-style4 secondary">
                  <span>Cotiza con nosotros</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SobreNosotros;
